<template>
    <div class="video">
        <img ref="outputImg" class="d-none">
        <div class="video-container" style="position: relative; width: 100%;">
            <video
                    class="media-video"
                    ref="videoDOM"
                    playsinline
                    muted
                    autoplay
                    @play="onPlay">
            </video>
            <div class="video-info" v-if="countdownStarted && isFaceDetected === false">
                {{ $t('modal_pre_checkin_face_recognition.photo_step.no_face') }}
            </div>
            <div class="video-info video-info-centered" v-if="invalidFaceInfoText">
                <p> {{ invalidFaceInfoText }} </p>
                <button class="btn btn-primary btn-sm" @click="resumeVideo">
                    {{ $t('modal_pre_checkin_face_recognition.photo_step.retake_photo') }}
                </button>
            </div>
            <div class="video-info video-info-centered" v-if="showLivenessHelp">
                <p> {{ $t('modal_pre_checkin_face_recognition.photo_step.liveness_help') }}</p>
            </div>
            <div class="video-countdown" v-if="countdownStarted">
                {{ countdownValue }}
            </div>
            <canvas class="media-canvas" ref="canvasDOM"></canvas>
            <canvas class="media-canvas" ref="canvasDetectionDOM" style="display: none"></canvas>
        </div>
    </div>
</template>

<script>
//import faceDetectorWorker from '@/workers'
import buttonBeep from '../assets/audio/button-beep.mp3'
import cameraShutter from '../assets/audio/camera-shutter.mp3'

export default {
    name: 'WebcamStreamFaceDetectorLiveness',
    props: {
        defaultCamera: {type: String, required: false, default: 'user'},
        isCountdownEnabled: {type: Boolean, required: false, default: false},
        isLiveness: {type: Boolean, required: false, default: false},
        forceResumeVideo: {type: Boolean, required: false, default: false}
    },
    watch: {
        isLiveness: function (newVal, oldVal) {
            if (newVal) {
                this.resumeVideo()
                this.showLivenessHelp = true
                setTimeout(() => this.showLivenessHelp = false, 3000)
            }
        },
        forceResumeVideo: function (newVal, oldVal) {
            if (newVal) {
                this.resumeVideo()
            }
        },
        isCountdownEnabled: function (newVal, oldVal) {
            if (newVal) {
                this.startCountdown()
            }
        },

    },
    data() {
        return {
            testMode: false,
            videoEl: {},
            canvasEl: {},
            canvasCtx: {},
            userMediaConstraints: {
                audio: false, // we don't require to have the audio
                video: {
                    width: {
                        min: 320,
                        ideal: screen.availHeight > screen.availWidth ? 580 : 1100, // 1280,
                        max: 1920
                    },
                    height: {
                        min: 240,
                        ideal: screen.availHeight > screen.availWidth ? 580 : 720, // 1280,
                        max: 1080
                    },
                    //  aspectRatio: 9/16,
                    frameRate: {
                        min: 15,
                        ideal: 30,
                        // max: 60
                    },
                    facingMode: this.defaultCamera
                }
            },
            scoreThreshold: 0.6, // min confidence threshold
            detectionInterval: 0,
            failCount: 0,
            successCount: 0,
            isFaceDetected: null,
            isPhotoTaken: false,
            countdownStarted: null,
            countdownValue: 0,
            beepAudio: null,
            maxFps: 30,
            canvasForDetectionEl: null,
            stream: null,
            detection: null,
            invalidFaceInfoText: null,

            showLivenessHelp: false
        };
    },
    created() {
        this.DETECT_W = 380
        this.DETECT_H = 440

    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.videoEl = this.$refs.videoDOM
            this.canvasEl = this.$refs.canvasDOM
            this.canvasForDetectionEl = this.$refs.canvasDetectionDOM
            this.beepAudio = new Audio(buttonBeep)
            this.beepAudio.volume = 0.1  // beep volume was too high
            this.cameraAudio = new Audio(cameraShutter)
            this.cameraAudio.volume = 0.5
            navigator.mediaDevices
                .getUserMedia(this.userMediaConstraints)
                .then(this.handleMediaStreamSuccess)
                .catch(this.handleMediaStreamError);
        },
        onPlay() {
            // prepare the image and canvas context
            this.canvasEl.height = this.videoEl.videoHeight
            this.canvasEl.width = this.videoEl.videoWidth
            this.canvasForDetectionEl.height = this.videoEl.videoHeight
            this.canvasForDetectionEl.width = this.videoEl.videoWidth
            this.canvasCtx = this.canvasEl.getContext('2d')
            this.canvasCtxForDetection = this.canvasForDetectionEl.getContext('2d')

            // let last = new Date()

            this.drawDetection(this.canvasCtx, (this.canvasEl.width / 2) - (this.DETECT_W / 2), (this.canvasEl.height / 2) - (this.DETECT_H / 2), this.DETECT_W, this.DETECT_H, true)
            //this.startCountdown()
            // Detect every 80 ms
            /* this.detectionInterval = setInterval(() => {
                 let dt = new Date() - last
                 this.handleVideoStream(this.videoEl, dt)

                 last = new Date()
             }, 80)*/
        },
        drawDetection(ctx, x, y, width, height, highlightCorners = false) {
            ctx.strokeStyle = '#1d6fff';
            ctx.lineWidth = 10;
            ctx.setLineDash([]);
            ctx.strokeRect(x, y, width, height);

            //ctx.filter = "blur(16px)";
            // MASK
            ctx.fillStyle = 'rgba(0,0,0,0.5)';
            ctx.fillRect(0, 0, (this.canvasEl.width / 2) - (this.DETECT_W / 2) - 5, this.canvasEl.height);


            ctx.fillRect((this.canvasEl.width / 2) - (this.DETECT_W / 2) + this.DETECT_W + 5, 0, (this.canvasEl.width / 2) - (this.DETECT_W / 2), this.canvasEl.height);

            ctx.fillRect((this.canvasEl.width / 2) - (this.DETECT_W / 2) - 5, 0, this.DETECT_W + 10, (this.canvasEl.height / 2) - (this.DETECT_H / 2) - 5);
            ctx.fillRect((this.canvasEl.width / 2) - (this.DETECT_W / 2) - 5, (this.canvasEl.height / 2) - (this.DETECT_H / 2) + this.DETECT_H + 5, this.DETECT_W + 10, (this.canvasEl.height / 2) - (this.DETECT_H / 2) - 4);

            if (highlightCorners) {
                const cornerWidth = width * 0.2
                const left = x
                const top = y
                const right = x + width
                const bottom = y + height

                ctx.beginPath();
                ctx.lineCap = 'round';
                ctx.strokeStyle = '#1d6fff';
                ctx.lineWidth = 10;
                ctx.moveTo(left, top + cornerWidth);
                ctx.lineTo(left, top);
                ctx.lineTo(left + cornerWidth, top);
                ctx.stroke();

                ctx.beginPath();
                ctx.moveTo(right - cornerWidth, top);
                ctx.lineTo(right, top);
                ctx.lineTo(right, top + cornerWidth);
                ctx.stroke();

                ctx.beginPath();
                ctx.moveTo(left, bottom - cornerWidth);
                ctx.lineTo(left, bottom);
                ctx.lineTo(left + cornerWidth, bottom);
                ctx.stroke();

                ctx.beginPath();
                ctx.moveTo(right - cornerWidth, bottom);
                ctx.lineTo(right, bottom);
                ctx.lineTo(right, bottom - cornerWidth);

                ctx.stroke();
            }
        },
        clearDrawings(canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        },
        handleMediaStreamSuccess(stream) {
            this.stream = stream;
            this.videoEl.srcObject = stream
            setTimeout(() => {
                this.$emit('streamAllowed')
              }, 500)
        },
        handleMediaStreamError(error) {
            this.$emit('streamNotAllowed', {error: error.name})
            let msg = ""
            switch (error.name) {
                case 'NotAllowedError':
                    msg = "It's not possible to access your camera at this time. Please make sure you have assigned permissions to the browser."
                    break
                case 'NotFoundError':
                    msg = "Seems like your device doesn't a camera."
                    break
                default:
                    msg = "We are sorry, but it's not possible to access your camera at this time."
                    break
            }
            alert(msg);
        },
        stopMediaStreamTrack() {
            this.videoEl.srcObject = null;
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop())
            }
        },
        pauseVideo() {
            this.videoEl.pause()
            this.isPhotoTaken = true
            if (this.detectionInterval) clearInterval(this.detectionInterval)
            if (this.isFaceDetected) {
                this.failCount = 0;
                this.successCount += 1;
                if (this.successCount > 10 && !this.countdownStarted) this.startCountdown()
            } else {
                // this.clearDrawings(this.canvasEl)
                this.failCount += 1;
                this.successCount = 0;
            }
        },
        resumeVideo() {
            this.videoEl.play()
            this.isPhotoTaken = false
            this.countdownStarted = false
            this.invalidFaceInfoText = null
        },
        /**
         * Switch front/back camera ("user" === front camera / "environment" === back)
         */
        switchCamera() {
            this.userMediaConstraints.video.facingMode = this.userMediaConstraints.video.facingMode === 'user' ? 'environment' : 'user'
            this.resetCountdown()
            this.stopMediaStreamTrack()
            this.init()
        },
        startCountdown(max = 3) {
            this.countdownValue = max;
            this.countdownStarted = true;
            //this.countdownInterval = setInterval(() => {
            //    this.countdownValue--;
            //    if (this.countdownValue === 0) {
            this.pauseVideo()
            this.resetCountdown()
            this.cameraAudio.play()

            let canvas = document.createElement('CANVAS')
            let ctx = canvas.getContext('2d')

            const detectionOffset = 120
            const photoDetectionW = this.DETECT_W + detectionOffset
            const photoDetectionH = this.DETECT_H + detectionOffset

            canvas.width = photoDetectionW
            canvas.height = photoDetectionH

            ctx.drawImage(this.videoEl, (this.canvasEl.width / 2) - (photoDetectionW / 2), (this.canvasEl.height / 2) - (photoDetectionH / 2), photoDetectionW, photoDetectionH, 0, 0, photoDetectionW, photoDetectionH)

            //ctx.drawImage(this.videoEl, 0, 0, this.canvasEl.width, this.canvasEl.height, 0, 0, this.canvasEl.width, this.canvasEl.height)

            this.$refs.outputImg.src = canvas.toDataURL('image/jpeg')
            canvas.toBlob(blob => {
                this.$emit('photoTaken', {faceImg: blob, isLiveness: this.isLiveness, faceEncoding: []})

            }, 'image/jpeg');
            //    } else {
            //        this.beepAudio.play()
            //    }
            //}, 1100)
        },
        resetCountdown() {
            this.countdownStarted = false
            this.countdownValue = 0
            this.invalidFaceInfoText = null
            clearInterval(this.countdownInterval)
        },
        setInvalidState(infoText) {
            // display validation error, then clear the bounding box
            this.invalidFaceInfoText = infoText
            this.clearDrawings(this.canvasEl)
        }
    },
    beforeDestroy() {
        this.pauseVideo()
        this.resetCountdown()
        this.stopMediaStreamTrack();
        // this.faceDetectorWorker.terminate()
        // this.faceDetectorWorker = null
    }
};
</script>

<style scoped>
.media-video {
    /* prevent flipping mode */
    transform: scaleX(-1);

    height: 100%;
    width: 100%;
    display: block;
    background-color: #242424;
}

.media-canvas {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
}

.video-container .video-info {
    position: absolute;
    z-index: 1;
    top: 1.5em;
    left: 50%;
    backdrop-filter: blur(10px);
    transform: translateX(-50%);
    background-color: rgba(75, 75, 75, 0.45);
    padding: .5em 2em;
    color: #ffffff;
    border-radius: 2em;
}

.video-container .video-info.video-info-centered {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.2rem;
    padding: 2em 2em;
}

.video-container .video-countdown {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.3;
    color: #ffffff;
    text-shadow: rgba(0, 0, 0, .4) 0 4px 5px;
    font-size: 16em;
}

.video-container .btn-take-photo {
    position: absolute;
    z-index: 1;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
}
</style>
